module.exports = __webpack_public_path__ + "img/LSY.f7802861.png";